import {
  afterNextRender,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  inject,
  signal,
} from '@angular/core';

@Component({
  selector: 'comp-dialog-content',
  templateUrl: 'dialog-content.component.html',
  styleUrls: ['dialog-content.component.scss'],
})
export class DialogContentComponent {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  private readonly showTopShadow = signal(false);
  private readonly showBottomFade = signal(false);
  private readonly resizeObserver = new ResizeObserver(() => this.updateScrollFade());

  @HostBinding('class.scroll-shadow-top')
  protected get hasTopShadow(): boolean {
    return this.showTopShadow();
  }

  @HostBinding('class.scroll-shadow-bottom')
  protected get hasBottomFade(): boolean {
    return this.showBottomFade();
  }

  constructor() {
    afterNextRender(() => {
      this.updateScrollFade();
      this.resizeObserver.observe(this.elementRef.nativeElement);
    });
  }

  @HostListener('scroll')
  protected onScroll(): void {
    this.updateScrollFade();
  }

  private updateScrollFade(): void {
    const contentContainer = this.elementRef.nativeElement;
    const hasOverflow = contentContainer.scrollHeight - contentContainer.clientHeight > 1;
    const isAtTop = contentContainer.scrollTop <= 1;
    const isAtBottom =
      contentContainer.scrollTop + contentContainer.clientHeight >=
      contentContainer.scrollHeight - 1;

    this.showTopShadow.set(hasOverflow && !isAtTop);
    this.showBottomFade.set(hasOverflow && !isAtBottom);
  }
}
